import { render } from "./ForceChart.vue?vue&type=template&id=3b853577"
import script from "./ForceChart.vue?vue&type=script&lang=js"
export * from "./ForceChart.vue?vue&type=script&lang=js"

import "./ForceChart.vue?vue&type=style&index=0&id=3b853577&lang=scss"
script.render = render

export default script